module.exports = __webpack_public_path__ + "static/media/traffic-road.31a42dd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-road.svg
// module id = 424
// module chunks = 0